/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIPatchedUserPreferencesRequestLanguage } from './APIPatchedUserPreferencesRequestLanguage';
import {
    APIPatchedUserPreferencesRequestLanguageFromJSON,
    APIPatchedUserPreferencesRequestLanguageFromJSONTyped,
    APIPatchedUserPreferencesRequestLanguageToJSON,
} from './APIPatchedUserPreferencesRequestLanguage';

/**
 * 
 * @export
 * @interface APIUserPreferencesRequest
 */
export interface APIUserPreferencesRequest {
    /**
     * 
     * @type {APIPatchedUserPreferencesRequestLanguage}
     * @memberof APIUserPreferencesRequest
     */
    language?: APIPatchedUserPreferencesRequestLanguage;
}

/**
 * Check if a given object implements the APIUserPreferencesRequest interface.
 */
export function instanceOfAPIUserPreferencesRequest(value: object): value is APIUserPreferencesRequest {
    return true;
}

export function APIUserPreferencesRequestFromJSON(json: any): APIUserPreferencesRequest {
    return APIUserPreferencesRequestFromJSONTyped(json, false);
}

export function APIUserPreferencesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIUserPreferencesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'language': json['language'] == null ? undefined : APIPatchedUserPreferencesRequestLanguageFromJSON(json['language']),
    };
}

export function APIUserPreferencesRequestToJSON(value?: APIUserPreferencesRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'language': APIPatchedUserPreferencesRequestLanguageToJSON(value['language']),
    };
}

